import { render } from "./FormCuti.vue?vue&type=template&id=23332d6a"
import script from "./FormCuti.vue?vue&type=script&lang=js"
export * from "./FormCuti.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__